import React, { Fragment } from 'react';

import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import moment from 'moment/moment.js';

import ErrorMessageContainer from '../form-input-error-message';
import CustomLabel from '../label';

const DateInputs = ({ data, errors, setErrors, setData, startDateOnBlur, endDateOnBlur }) => {
	const minDate = Date.now();
	const StartDate = data.StartDate ? moment(data.StartDate).toDate() : null;
	const EndDate = data.EndDate ? moment(data.EndDate).toDate() : null;

	const handleStartDateChange = (date) => {
		setData({ ...data, StartDate: date });
		setErrors({ ...errors, StartDate: '' });
	};

	const handleEndDateChange = (date) => {
		setData({ ...data, EndDate: date });
		setErrors({ ...errors, EndDate: '' });
	};

	return (
		<Fragment>
			<div className="p-2 w-4/6">
				<CustomLabel labelFor="title">تاریخ شروع</CustomLabel>
				<DatePicker
					name="StartDate"
					minDate={minDate}
					onBlur={startDateOnBlur}
					dateFormat="dd/MM/yyyy"
					placeholderText="dd/MM/yyyy"
					className="w-full bg-gray-100 rounded border border-gray-400 focus:outline-none focus:border-teal-500 text-base px-4 py-2"
					selected={StartDate}
					onChange={handleStartDateChange}
				/>
				{errors.StartDate ? <ErrorMessageContainer>{errors.StartDate}</ErrorMessageContainer> : null}
			</div>
			<div className="p-2 w-4/6">
				<CustomLabel labelFor="title">تاریخ پایان</CustomLabel>
				<DatePicker
					name="EndDate"
					minDate={minDate}
					onBlur={endDateOnBlur}
					dateFormat="dd/MM/yyyy"
					placeholderText="dd/MM/yyyy"
					className="w-full bg-gray-100 rounded border border-gray-400 focus:outline-none focus:border-teal-500 text-base px-4 py-2 resize-none block"
					selected={EndDate}
					onChange={handleEndDateChange}
				/>
				{errors.EndDate ? <ErrorMessageContainer>{errors.EndDate}</ErrorMessageContainer> : null}
			</div>
		</Fragment>
	);
};

export default DateInputs;
